<div class="wrapper d-flex align-items-stretch">
  <!-- Left Sidebar with Categories -->
  <ozm-sidebar></ozm-sidebar>

  <!--PageContent-->
  <div id="content" class="p-4 p-md-5">
    <div class="top-wr">
      <ozm-header></ozm-header>
      
      <!-- Main Content Area -->
      <div class="container">
        <!-- Category Header -->
        <div class="category-header" *ngIf="category">
          <div class="category-info">
            <img [src]="category.iconPath || '/assets/images/default-category.png'" 
                 [alt]="category.name"
                 class="category-icon"
                 (error)="handleImageError($event)">
            <h1 class="category-title">{{ category.name }}</h1>
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="loading-container">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p>Loading category details...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !loading" class="alert alert-danger">
          {{ error }}
        </div>

        <!-- Main Content -->
        <div class="content-wrapper" *ngIf="!loading && !error">
          <!-- Subcategories Section (Main Area - LEFT SIDE) -->
          <main class="subcategories-section">
            <h2 class="text-white">Choose Your Favorites</h2>
      
            <div *ngIf="subcategories.length === 0" class="no-subcategories">
              <p>No subcategories available for this category.</p>
            </div>

            <!-- Subcategory Accordions -->
            <div class="accordion-container" *ngFor="let subcategory of subcategories">
              <div class="accordion-item">
                <!-- Accordion Header -->
                <div class="accordion-header" 
                     [class.has-favorite]="hasFavorite(subcategory.subCategoryId)"
                     [class.expanded]="isExpanded(subcategory.subCategoryId)">
                  <div class="header-left" (click)="toggleAccordion(subcategory.subCategoryId)">
                    <span class="subcategory-name">{{ subcategory.name }}</span>
                    <span class="favorite-badge" *ngIf="hasFavorite(subcategory.subCategoryId)">
                      <i class="fas fa-star"></i>
                    </span>
                  </div>
                  
                  <div class="header-right">
                    <!-- Open All Button (only show if has favorites) -->
                    <button class="btn-open-all"
                            *ngIf="hasFavorite(subcategory.subCategoryId)"
                            (click)="openAllApps(subcategory.subCategoryId)"
                            title="Open all favorite apps">
                      <i class="fas fa-external-link-alt"></i>
                      <span class="btn-text">Open All</span>
                    </button>
                    
                    <!-- Add Button (always visible) -->
                    <button class="btn-add-favorite"
                            (click)="openCategoryPageForSubcategory(subcategory)"
                            title="Add/Change favorite app">
                      <i class="fas fa-plus"></i>
                      <span class="btn-text">{{ hasFavorite(subcategory.subCategoryId) ? 'Change' : 'Add Favorite' }}</span>
                    </button>
                    
                    <!-- Expand/Collapse Icon -->
                    <button class="btn-expand"
                            (click)="toggleAccordion(subcategory.subCategoryId)"
                            title="Expand/Collapse">
                      <i class="fas" 
                         [class.fa-chevron-down]="!isExpanded(subcategory.subCategoryId)"
                         [class.fa-chevron-up]="isExpanded(subcategory.subCategoryId)">
                      </i>
                    </button>
                  </div>
                </div>

                <!-- Accordion Body (always present, visibility controlled by CSS) -->
                <div class="accordion-body" 
                     [class.show]="isExpanded(subcategory.subCategoryId)">
                  
                  <!-- Has Favorites - Show All App Cards -->
                  <!-- Has Favorites - Show All App Cards in 4-column grid -->
                  <div *ngIf="hasFavorite(subcategory.subCategoryId)">
                    <div class="app-cards-grid">
                      <div class="favorite-app-card" 
                           *ngFor="let favorite of getFavorites(subcategory.subCategoryId)">
                        <img [src]="getAppIcon(favorite)"
                             [alt]="favorite.appName"
                             class="app-icon"
                             (error)="handleAppImageError($event)">
                        
                        <div class="app-details">
                          <h4>{{ favorite.appName }}</h4>
                          <p class="app-category">{{ subcategory.name }}</p>
                        </div>

                        <div class="app-actions">
                          <button class="btn-open" 
                                  (click)="openApp(favorite)"
                                  title="Open app">
                            <i class="fas fa-external-link-alt"></i> Open
                          </button>
                          <button class="btn-remove"
                                  (click)="removeFavorite(subcategory.subCategoryId, favorite.appliId)"
                                  title="Remove favorite">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Add More Button -->
                    <div class="add-more-section">
                      <button class="btn-add-more"
                              (click)="openCategoryPageForSubcategory(subcategory)">
                        <i class="fas fa-plus-circle"></i> Add More Apps
                      </button>
                    </div>
                  </div>
                  
                  <!-- No Favorite - Show Empty State -->
                  <div class="no-favorite-state" *ngIf="!hasFavorite(subcategory.subCategoryId)">
                    <div class="empty-icon">
                      <i class="fas fa-inbox"></i>
                    </div>
                    <p class="empty-message">No app selected</p>
                    <button class="btn-select-app"
                            (click)="openCategoryPageForSubcategory(subcategory)">
                      <i class="fas fa-plus-circle"></i> Select an App
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </main>

          <!-- Offers Section - Uses PUBLIC /offer/front endpoint (same pattern as /category/front) -->
          <aside class="offers-section">
            <h3 class="text-white">Special Offers</h3>
            
            <div *ngIf="offersLoading" class="offers-loading">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="sr-only">Loading offers...</span>
              </div>
              <p class="loading-text">Loading offers...</p>
            </div>

            <div class="offers-list" *ngIf="!offersLoading">
              <div class="offer-card dynamic-offer" 
                   *ngFor="let offer of offers"
                   (click)="openOffer(offer)"
                   [title]="offer.title">
                <div class="offer-icon-wrapper">
                  <img [src]="getOfferBanner(offer)" 
                       [alt]="offer.title"
                       class="offer-icon"
                       (error)="handleOfferImageError($event)">
                </div>
                <div class="offer-content">
                  <h4 class="offer-title">{{ offer.title }}</h4>
                  <p class="offer-subtitle" *ngIf="offer.link">Click to view offer</p>
                </div>
                <div class="offer-arrow">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>

              <div class="no-offers" *ngIf="offers.length === 0">
                <i class="fas fa-tag"></i>
                <p>No special offers available at the moment</p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  </div>
</div>
